
const digest = 'b9ff5bfe1b6a3b2b75cc1a354528f882902caed45bbd54064f90ea3c022d67e3';
const classes = {"button":"_button_hulkn_1"};
const css = `._button_hulkn_1 {
  margin-top: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  